// extracted by mini-css-extract-plugin
module.exports = {"divBar":"prgressBarSalary_divBar__2nND6"};